import { Box, makeStyles, Typography } from "@material-ui/core";
import * as React from "react";

import { PublicHeader } from "@/components/PublicHeader";
import { useDevice } from "@/hooks/useDevice";
import theme from "@/theme";

const useStyles = makeStyles(() => ({
  root: {
    minHeight: "100vh",
    backgroundColor: theme.palette.semantic["surface/card"],
    [theme.breakpoints.up("md")]: { backgroundColor: theme.palette.semantic["surface/base"] },
  },
  main: {
    width: "100%",
    padding: "calc(32px + env(safe-area-inset-top, 0px)) 24px calc(32px + env(safe-area-inset-bottom, 0px))",
    [theme.breakpoints.up("md")]: {
      width: 560,
      padding: "40px 48px",
      margin: "48px auto 64px",
      borderRadius: 16,
      backgroundColor: theme.palette.semantic["surface/card"],
    },
    "& .MuiFormControl-root": { margin: 0 },
    "& .MuiTypography-h5": { [theme.breakpoints.up("md")]: { "&&": { fontSize: 14 } } },
  },
  heading: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 1.3,
    textAlign: "center",
    [theme.breakpoints.up("md")]: { fontSize: 20 },
  },
  description: {
    fontSize: 14,
    lineHeight: 1.5,
    textAlign: "center",
    color: theme.palette.text.secondary,
    marginTop: 8,
  },
  mark: { display: "flex", justifyContent: "center", marginBottom: 24 },
  body: { marginTop: 24 },
  actions: { width: "100%", margin: "32px auto 0", [theme.breakpoints.up("md")]: { maxWidth: 360 } },
}));

/** ログイン・パスワード再設定の公開画面。登録にはRegistrationFlowLayoutを使う。 */
export const EntranceTemplate: React.FC<{
  children: React.ReactNode;
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  mark?: React.ReactNode;
}> = ({ children, title, subTitle, mark }) => {
  const { isMobile } = useDevice();
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      {!isMobile && <PublicHeader />}
      <Box component="main" className={classes.main} data-auth-layout>
        {mark && <Box className={classes.mark}>{mark}</Box>}
        <Typography component="h1" className={classes.heading}>
          {title}
        </Typography>
        {subTitle && (
          <Typography component="div" className={classes.description}>
            {subTitle}
          </Typography>
        )}
        <Box className={classes.body}>{children}</Box>
      </Box>
    </Box>
  );
};

export const EntranceActions: React.FC = ({ children }) => {
  const classes = useStyles();
  return <Box className={classes.actions}>{children}</Box>;
};
